"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ajax = void 0;
const wm_portal_lib_api_core_1 = require("@webmotors/wm-portal-lib-api-core");
const configuration_1 = require("../configuration");
const ajaxFairs = new wm_portal_lib_api_core_1.AjaxCreator({
    baseURL: () => configuration_1.getConfigurationLib().baseURLFairs,
    initialHeaders: {
        'Content-type': 'application/json',
    },
});
exports.ajax = ajaxFairs.ajax;
//# sourceMappingURL=index.js.map